// Layout/navIcons — the registry names its icons by react-icons/fi identifier;
// this is the one map from that name to an element (rail, dock and the More sheet).
import React from 'react';
import {
  FiHome, FiFileText, FiUsers, FiCalendar, FiPhone, FiTrendingUp, FiBarChart2, FiTag,
  FiSettings, FiDollarSign, FiMessageSquare, FiClipboard, FiTruck, FiUserPlus,
  FiShoppingBag, FiZap, FiGrid,
} from 'react-icons/fi';

const MAP = {
  FiHome, FiFileText, FiUsers, FiCalendar, FiPhone, FiTrendingUp, FiBarChart2, FiTag,
  FiSettings, FiDollarSign, FiMessageSquare, FiClipboard, FiTruck, FiUserPlus,
  FiShoppingBag, FiZap, FiGrid,
};

export default function navIcon(name, size = 20) {
  const Cmp = MAP[name] || FiHome;
  return <Cmp size={size} aria-hidden="true" />;
}
